module.exports = __webpack_public_path__ + "static/media/qr_code.15e11202.png";